import * as React from "react";
import * as qs from "query-string";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { Loader } from "src/common/components";
import { IAppReduxState, IUser } from "src/common/types";
import { fetchCurrentUser as getCurrentUser } from "../redux/actions";
import { Dispatch } from "redux";

interface IOwnProps {
  children: React.ReactNode;
  lng: string;
}

interface IStateProps {
  authFailed: boolean;
  userData: IUser;
  openTasksCompleted: boolean;
}

interface IDispatchProps {
  fetchCurrentUser: () => void;
}

type Props = IStateProps & IOwnProps & IDispatchProps;

const CurrentUserProvider = ({ authFailed, children, fetchCurrentUser, lng, openTasksCompleted, userData }: Props) => {
  /**
   * Attempt to fetch current user
   */
  React.useEffect(() => {
    fetchCurrentUser();
  }, []);

  /**
   * check user information if has been fetched,
   * means user has been authorized
   */
  if (openTasksCompleted && userData) {
    /**
     * User is authorized here
     */
    const nextUrl = sessionStorage.getItem("nextUrl");

    if (nextUrl) {
      sessionStorage.removeItem("nextUrl");
      return <Redirect to={`/${lng}/${nextUrl}`} />;
    } else {
      return <>{children}</>;
    }
  } else if (authFailed) {
    /**
     * User is not authorized section
     * Attempt
     */

    // if link has some path like /en/manager-dashboard/... use this link as nextUrl or redirect to dashboard/forward as default

    const nextUrl = (location.pathname + location.search).slice(4);

    sessionStorage.setItem("nextUrl", nextUrl);

    const queryParams = {
      nextUrl
    };
    return <Redirect to={`/${lng}/login?${qs.stringify(queryParams)}`} />;
  }

  /**
   * Return `null` if we don't know if user is authorized or not
   */
  return <Loader />;
};

const mapStateToProps = ({ currentUser }: IAppReduxState): IStateProps => ({
  ...currentUser,
  openTasksCompleted: currentUser.openTasks.completed
});

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  fetchCurrentUser: () => dispatch(getCurrentUser())
});

export default React.memo(
  connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(CurrentUserProvider)
);
